/* eslint-disable react/no-danger */
import React from 'react';
import styled from 'styled-components';

import images from '_images';
import { _ } from '_locales';
import { colors } from '_styles';
import { Contact } from '../../DepoEvents_Components';

const Container = styled.div`
  width: 100%;
  height: 100%;
  background-color: #fff;
`;

const Text = styled.h4`
  font-size: 16px !important;
  font-weight: 400px !important;
  margin: 5px 0;
`;

const HoursText = styled.div`
  all: initial;
  font-family: Roboto, sans-serif !important;
  position: relative;
  font-size: 15px !important;
  font-weight: 500 !important;
  display: block;
  color: #404040 !important;

  p {
    margin: 0 !important;
    line-height: 1em !important;
  }

  strong {
    font-size: 13px !important;
    font-weight: bold !important;
    color: ${colors.GREY} !important;
  }

  ul {
    margin-top: 10px !important;
  }

  li {
    line-height: 1em;
  }
`;

const P = styled.span`
  margin-left: 35px !important;
  font-weight: bold !important;
  &:before {
    content: '';
    position: absolute;
    left: 0;
    top: 0;
    bottom: 0;
    margin: auto;
    width: 17px;
    height: 17px;
    margin: 13px 0;
    background-size: 17px;
    background-repeat: no-repeat;
    background-image: url(${images.icons.hrs});
  }
`;

const HoursContainer = styled.div`
  display: block;
  padding: 0 35px;
   
  margin-bottom: 10px;
`;

const Day = styled.span`
  margin-right: 20px;
  font-size: 14px !important;
  font-weight: 400 !important;
  color: #404040 !important;

`;

const Time = styled.span`
  font-size: 14px !important;
  font-weight: 400 !important;
  color: #404040 !important;
`;

const Gap = styled.div`
  margin-top: 30px;
`;

const LocationInformationComponent = ({
  season, webAdr, phoneNbr, emailAdr
}) => (
  <Container>
    {
      (
        phoneNbr
        && !phoneNbr.includes('null')
      )
        || (
          emailAdr
          && !emailAdr.includes('null')
        ) || (
          season
          && season.length
        ) ? (
        <>
          {
            season
              && season.length ? ([
                <Text>{_('wgw.hours_of_operation')}</Text>,
                season.map(({ season_nm, season_notes, hours }) => (
                  <div key={`${season_nm}@${Math.random()}`}>
                    <HoursText>
                      <P>{season_nm}</P>
                      <div
                        dangerouslySetInnerHTML={{ __html: season_notes }}
                        style={{ marginLeft: '35px', marginTop: 5 }}
                      />
                    </HoursText>

                    {
                      hours
                        && hours
                        ? hours.map(({ format_days, format_hours_lower, format_hours_upper }) => (
                          <HoursContainer key={`${format_days}@${format_hours_lower}@${format_hours_upper}`}>
                            <Day>{format_days}</Day>
                            <Time>{format_hours_lower}</Time>
                            {' - '}
                            <Time>{format_hours_upper}</Time>
                          </HoursContainer>
                        ))
                        : null
                    }
                  </div>
                ))
              ]) : null
          }

          <Gap />

          <Contact
            phone={phoneNbr}
            email={emailAdr}
            link={webAdr}
          />
        </>
      ) : null
    }
  </Container>
);

export default LocationInformationComponent;
